
PP.Handedness = {
    NONE: "none",
    LEFT: "left",
    RIGHT: "right",
};

PP.HandednessIndex = {
    NONE: 0,
    LEFT: 1,
    RIGHT: 2,
};

PP.InputSourceType = {
    NONE: 0,
    GAMEPAD: 1,
    HAND: 2
};